module.exports = "/_next/static/images/3D@2x-0834b695012c1b720e42b9eea7bc64e2.png";